export const VALID_GUESSES = [
  'ander',
  'annie',
  'bella',
  'britt',
  'chris',
  'holly',
  'kiera',
  'marie',
  'mutti',
]